// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39UZt","index":"styles_index__s2yes"};